import {makeStyles} from "@material-ui/core/styles";
import LanguageHelper from "../../../../helpers/LanguageHelper";
import {latestArtifactStatusTranslations} from "../../../../assets/constants";
import React from "react";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        gap: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    infoBox: {
        flex: 1,
        backgroundColor: "#fff",
        borderRadius: 12,
        overflow: "hidden",
        boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.05) 0px 8px 15px",
        transition: "transform 0.2s ease",
        "&:hover": {
            transform: "translateY(-2px)",
        },
    },
    sectionTitle: {
        backgroundColor: "#1976d2",
        padding: theme.spacing(2),
        color: "#fff",
        fontSize: "1.1rem",
        fontWeight: 600,
        textAlign: "center",
        letterSpacing: "0.5px",
        background: "linear-gradient(90deg, #1976d2 0%, #1565c0 100%)",
    },
    content: {
        padding: theme.spacing(3, 4),
    },
    infoItem: {
        marginBottom: theme.spacing(3),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    label: {
        color: "#64748B",
        fontSize: "0.875rem",
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },
    value: {
        backgroundColor: "#F8FAFC",
        padding: theme.spacing(2),
        borderRadius: 8,
        color: "#334155",
        fontSize: "0.95rem",
        lineHeight: 1.6,
        whiteSpace: "pre-line",
        border: "1px solid #E2E8F0",
    },
    statusContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    statusValue: {
        display: "inline-flex",
        alignItems: "center",
        padding: theme.spacing(1.5, 2.5),
        borderRadius: 8,
        fontSize: "0.875rem",
        fontWeight: 600,
        letterSpacing: "0.3px",
    },
    failedStatus: {
        backgroundColor: "rgba(239, 68, 68, 0.1)",
        color: "#DC2626",
        border: "1px solid rgba(239, 68, 68, 0.2)",
    },
    inProgressStatus: {
        backgroundColor: "rgba(234, 179, 8, 0.1)",
        color: "#B45309",
        border: "1px solid rgba(234, 179, 8, 0.2)",
    },
    deployedStatus: {
        backgroundColor: "rgba(34, 197, 94, 0.1)",
        color: "#16A34A",
        border: "1px solid rgba(34, 197, 94, 0.2)",
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: "50%",
        marginRight: theme.spacing(1),
    },
    failedDot: {
        backgroundColor: "#DC2626",
    },
    inProgressDot: {
        backgroundColor: "#B45309",
    },
    deployedDot: {
        backgroundColor: "#16A34A",
    },
}));

const InfoSection = ({ title, data }) => {
    const classes = useStyles();
    const language = LanguageHelper.getLanguage();

    const getStatusClasses = (status) => {
        const baseClasses = classes.statusValue;
        switch (status) {
            case "READY_TO_DEPLOY":
            case "IN_PROGRESS":
                return `${baseClasses} ${classes.inProgressStatus}`;
            case "FAILED":
                return `${baseClasses} ${classes.failedStatus}`;
            case "DEPLOYED":
                return `${baseClasses} ${classes.deployedStatus}`;
            default:
                return baseClasses;
        }
    };

    const getStatusDotClasses = (status) => {
        const baseClasses = classes.statusDot;
        switch (status) {
            case "READY_TO_DEPLOY":
            case "IN_PROGRESS":
                return `${baseClasses} ${classes.inProgressDot}`;
            case "FAILED":
                return `${baseClasses} ${classes.failedDot}`;
            case "DEPLOYED":
                return `${baseClasses} ${classes.deployedDot}`;
            default:
                return baseClasses;
        }
    };

    return (
        <div className={classes.infoBox}>
            <div className={classes.sectionTitle}>{title}</div>
            <div className={classes.content}>
                {data ? (
                    <>
                        <div className={classes.infoItem}>
                            <div className={classes.label}>
                                {language.applicationUpdates.latestArtifact}
                            </div>
                            <div className={classes.value}>{data.dateTime}</div>
                        </div>
                        <div className={classes.infoItem}>
                            <div className={classes.label}>
                                {language.applicationUpdates.status}
                            </div>
                            <div className={getStatusClasses(data.status)}>
                                <span className={getStatusDotClasses(data.status)} />
                                {latestArtifactStatusTranslations[data.status]}
                            </div>
                        </div>
                        <div className={classes.infoItem}>
                            <div className={classes.label}>
                                {language.applicationUpdates.description}
                            </div>
                            <div className={classes.value}>{data.description}</div>
                        </div>
                    </>
                ) : (
                    <div className={classes.value}>No updates available</div>
                )}
            </div>
        </div>
    );
};


export { InfoSection , useStyles};
